import React from "react";
import point1 from "../../assets/images/embellishments/points/point_01.svg";
import point2 from "../../assets/images/embellishments/points/point_02.svg";
import point3 from "../../assets/images/embellishments/points/point_03.svg";
import point4 from "../../assets/images/embellishments/points/point_04.svg";
import point5 from "../../assets/images/embellishments/points/point_05.svg";
import point6 from "../../assets/images/embellishments/points/point_06.svg";
import point7 from "../../assets/images/embellishments/points/point_07.svg";
import point8 from "../../assets/images/embellishments/points/point_08.svg";
import point9 from "../../assets/images/embellishments/points/point_09.svg";
import point10 from "../../assets/images/embellishments/points/point_10.svg";
import point11 from "../../assets/images/embellishments/points/point_11.svg";
import point12 from "../../assets/images/embellishments/points/point_12.svg";
import "./index.scss";
import Features from "../Features";

interface PointDecorFeaturesProps {
  folder: string;
}

const PointDecorFeatures: React.FC<PointDecorFeaturesProps> = ({ folder }) => {
  return (
    <>
      <div className="yellow-highlight"></div>
      <div className="features" style={{ height: "2880px" }}>
        <div className="embel-position point-1">
          <img src={point1} alt="point_01_私の写真ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-2">
          <img src={point2} alt="point_02_私の名前ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-3">
          <img src={point3} alt="point_03_私の容姿ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-4">
          <img src={point4} alt="point_04_私の容姿ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-5">
          <img src={point5} alt="point_05_私の容姿ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-6">
          <img src={point6} alt="point_06_私の紙ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-7">
          <img src={point7} alt="point_07_私の容姿ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-8">
          <img src={point8} alt="point_08_私の容姿ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-9">
          <img src={point9} alt="point_09_私の容姿ポイント" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position point-10">
          <img
            src={point10}
            alt="point_10_私の容姿ポイント"
            className="embel"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="embel-position point-11">
          <img
            src={point11}
            alt="point_11_私の容姿ポイント"
            className="embel"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="embel-position point-12">
          <img
            src={point12}
            alt="point_12_私の容姿ポイント"
            className="embel"
            loading="lazy"
            decoding="async"
          />
        </div>

        <Features folder={folder} />
      </div>
    </>
  );
};

export default PointDecorFeatures;
